import styled from "styled-components";

export const StyledOrders = styled.div`

`;